module.exports = __webpack_public_path__ + "static/media/bank_of_ireland.2cde267c.jpg";